import type { AxiosResponse } from "axios"

export const getBlob = (response: AxiosResponse<any>) => {
  return new Blob([response.data], { type: response.data.type })
}

export const getFileName = (response: AxiosResponse<any>) => {
  const contentDisposition = response.headers["content-disposition"]
  if (!contentDisposition) {
    return
  }

  const utf8matches = /filename\*=(utf8|UTF-8)''([^;\n]*)/.exec(contentDisposition)
  if (utf8matches !== null && utf8matches[2]) {
    // デコードするとスペースが"+"になるのでスペースへ置換します
    return decodeURI(utf8matches[2]).replace(/\+/g, " ")
  }

  const matches = /filename=(['"]?)([^;\n'"]*)/.exec(contentDisposition)
  if (matches !== null && matches[2]) {
    // デコードするとスペースが"+"になるのでスペースへ置換します
    return decodeURI(matches[2]).replace(/\+/g, " ")
  }
}
